import axios from '../erp/configAxios';

export const deleteClientApi = async (user_id) => {
    return await axios.delete(`/${user_id}/delete/`);
  };
